var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.path==='/')?_c('moveComponents',{staticClass:"red-rain-icon-box",attrs:{"magnetic":true,"limitPosition":{left:20,right:20,bottom:90,top:140}}},[_c('div',{on:{"click":_vm.showRain}},[_c('img',{attrs:{"src":require("@/assets/images/red-rain-icon.png"),"alt":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }